/**
 * Token utility functions for admin authentication
 */

export const getTokenInfo = () => {
  const token = localStorage.getItem("adminToken");
  const expiry = localStorage.getItem("adminTokenExpiry");
  const refreshToken = localStorage.getItem("adminRefreshToken");
  
  return {
    hasToken: !!token,
    token,
    expiry,
    refreshToken,
    isExpired: isTokenExpired(),
    expiresIn: getTimeUntilExpiry()
  };
};

export const isTokenExpired = () => {
  const expiry = localStorage.getItem("adminTokenExpiry");
  if (!expiry) return true;
  
  const expiryDate = new Date(expiry);
  const now = new Date();
  
  // Check if token expires within the next 5 minutes (buffer time)
  const bufferTime = 5 * 60 * 1000; // 5 minutes in milliseconds
  return (expiryDate.getTime() - now.getTime()) <= bufferTime;
};

export const getTimeUntilExpiry = () => {
  const expiry = localStorage.getItem("adminTokenExpiry");
  if (!expiry) return 0;
  
  const expiryDate = new Date(expiry);
  const now = new Date();
  
  return Math.max(0, expiryDate.getTime() - now.getTime());
};

export const formatTimeUntilExpiry = () => {
  const timeLeft = getTimeUntilExpiry();
  if (timeLeft <= 0) return "Expired";
  
  const minutes = Math.floor(timeLeft / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  
  if (days > 0) return `${days}d ${hours % 24}h`;
  if (hours > 0) return `${hours}h ${minutes % 60}m`;
  return `${minutes}m`;
};